/**
 * Event name constants for tracking platforms
 */
export const EventNames = {
  // Page events
  PAGE_VIEWED: "Page Viewed",

  // Interaction events
  BUTTON_CLICKED: "Button Clicked",
  FORM_SUBMITTED: "Form Submitted",

  // Product events
  PRODUCT_VIEWED: "Product Viewed",
  ADDED_TO_CART: "Added To Cart",
  REMOVED_FROM_CART: "Removed From Cart",

  // Checkout events
  CHECKOUT_STARTED: "Checkout Started",
  PURCHASE_COMPLETED: "Purchase Completed",

  // Search events
  SEARCH: "Search",

  // User events
  USER_SIGNED_UP: "User Signed Up",
  USER_LOGGED_IN: "User Logged In",
};

/**
 * Default currency code
 */
export const DEFAULT_CURRENCY = "INR";

export const HARDCODED_HANDLE = "ryze-gums";
